import { ConsumablesProductDetailsProvider } from "@product-details/providers/ConsumablesProductDetailsProvider";
import { ReactQueryClientProvider } from "@product-details/providers/ReactQueryClientProvider";

import { ConsumablesProductDetails } from "./components/ConsumablesProductDetails";

import { type ConsumablesProductDetailsData } from "./ConsumablesProductDetailsContainer.types";

export const ConsumablesProductDetailsContainer = (props: ConsumablesProductDetailsData) => {
  return (
    <ConsumablesProductDetailsProvider data={props}>
      <ReactQueryClientProvider>
        <ConsumablesProductDetails />
      </ReactQueryClientProvider>
    </ConsumablesProductDetailsProvider>
  );
};
